import { VenueCard } from './VenueCard';
import { type VenueRating } from '@/services/venueRatingsService';

interface Venue {
  id: string;
  venue_name: string;
  address: string;
  city: string;
  state_province: string;
  phone_number?: string;
  website?: string;
  operating_hours?: string;
  amenities?: string[];
  sports_available?: string[];
  rating?: number;
  price_range?: string;
  description?: string;
  profile_photo_url?: string;
  hourly_rates?: number;
}

interface VenuesGridProps {
  venues: Venue[];
  loading?: boolean;
  onVenueContact?: (venue: Venue) => void;
  onVenueDetails?: (venue: Venue) => void;
  ratingsMap?: Record<string, VenueRating>;
}

export const VenuesGrid = ({ venues, loading, onVenueContact, onVenueDetails, ratingsMap }: VenuesGridProps) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-800 rounded-lg h-80"></div>
          </div>
        ))}
      </div>
    );
  }

  if (venues.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-400 text-lg mb-2">No venues found</div>
        <div className="text-gray-500">Try adjusting your search criteria</div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {venues.map((venue) => {
        const rating = ratingsMap?.[venue.id];
        return (
          <VenueCard
            key={venue.id}
            venue={{
              ...venue,
              rating: rating?.average
            }}
            ratingCount={rating?.count}
            onContact={() => onVenueContact?.(venue)}
            onViewDetails={() => onVenueDetails?.(venue)}
          />
        );
      })}
    </div>
  );
};